import { Form } from '@mairistem/composants';

import { formatMonetaire } from '@/utils';

interface PaiementEnLigneProps {
  /** Libellé du mode : « Carte bancaire par internet » ou « Prélèvement par internet ». */
  libelle: string;
  /** Référence PayFiP de la transaction, portée par le règlement. */
  numero?: string | null;
  montant: number;
}

/**
 * Règlement d'un paiement fait en ligne sur Mon Espace Famille (CBI ou PRI), redescendu de MFO.
 * Il n'est jamais saisi au guichet : on n'en affiche que le mode, la référence PayFiP et le montant.
 */
const PaiementEnLigne = (props: PaiementEnLigneProps) => {
  const { libelle: libelleProps, numero: numeroProps, montant: montantProps } = props;

  return (
    <Form.Group style={{ margin: 0, flex: 1 }}>
      <Form.Field inline width={4}>
        <label>{libelleProps}</label>
      </Form.Field>
      <Form.Field inline width={4}>
        Référence PayFiP
        {' : '}
        <label>{numeroProps}</label>
      </Form.Field>
      <Form.Field
        inline
        width={8}
        // @ts-expect-error
        style={{ textAlign: 'right' }}
      >
        Montant
        {' : '}
        <label>{formatMonetaire(montantProps, 2)}</label>
      </Form.Field>
    </Form.Group>
  );
};

export default PaiementEnLigne;
